export function getSacAppBaseApiUrl(): string {
    const url = process.env.REACT_APP_API_URL as string;

    if (url.slice(-1) === '/') {
        return url.slice(0, -1);
    }

    return url as string;
}
